import React, { useState, useEffect } from "react";
import "./headboardEvents.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

// Components //
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';

const HeadboardEvents = (props: ReferenciaCabecera) => {
    const { isBrowser, window } = useBrowserMode();
    const [pathname, setPathname] = useState("");

    useEffect(() => {
        const getPathname = () => {
            if(isBrowser) {
                if (window.location.pathname.includes("personas")) {
                    setPathname("Personas")
                }
                if (window.location.pathname.includes("empresas")) {
                    setPathname("Empresas")
                }
                if (window.location.pathname.includes("personas") && window.location.pathname.includes("comunidades")) {
                    setPathname("Comunidades")
                }
            }
        }

        getPathname();
    }, [])
    
    return (
        <div className={`o-headboard-events`}>
            <div className="container">
                <Breadcrumb content={ `Inicio / ${pathname} / ${props.tituloPrincipal}` } />
                <div className="o-headboard-events__container">
                    <div className="o-headboard-events__container__content">
                        {props.tituloPrincipal && (
                            <h1 className="o-headboard-events__container__content__title">
                                {props.tituloPrincipal}
                            </h1>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeadboardEvents;
